var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59395 7.49454H13.0776C13.4886 7.49454 13.8248 7.15827 13.8248 6.74727C13.8248 6.33627 13.4886 6 13.0776 6H8.59395C8.18295 6 7.84668 6.33627 7.84668 6.74727C7.84668 7.15827 8.18295 7.49454 8.59395 7.49454Z",
    fill: "#6FCAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11055 9.73624H13.0778C13.4888 9.73624 13.8251 9.39997 13.8251 8.98897C13.8251 8.57797 13.4888 8.2417 13.0778 8.2417H4.11055C3.69955 8.2417 3.36328 8.57797 3.36328 8.98897C3.36328 9.39997 3.69955 9.73624 4.11055 9.73624Z",
    fill: "#6FCAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86739 11.9779H10.8346C11.2456 11.9779 11.5819 11.6417 11.5819 11.2307C11.5819 10.8197 11.2456 10.4834 10.8346 10.4834H1.86739C1.45639 10.4834 1.12012 10.8197 1.12012 11.2307C1.12012 11.6417 1.45639 11.9779 1.86739 11.9779Z",
    fill: "#6FCAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9126 13.4724C23.9126 13.0614 23.5763 12.7251 23.1654 12.7251H0.747269C0.336271 12.7251 0 13.0614 0 13.4724C0 13.8834 0.336271 14.2196 0.747269 14.2196H23.1654C23.5763 14.2196 23.9126 13.8834 23.9126 13.4724Z",
    fill: "#6FCAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1646 14.9673H1.86739C1.45639 14.9673 1.12012 15.3036 1.12012 15.7146C1.12012 16.1256 1.45639 16.4618 1.86739 16.4618H23.1646C23.5756 16.4618 23.9118 16.1256 23.9118 15.7146C23.9118 15.3036 23.5756 14.9673 23.1646 14.9673Z",
    fill: "#6FCAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59417 17.209H4.11055C3.69955 17.209 3.36328 17.5415 3.36328 17.9563C3.36328 18.371 3.69955 18.7035 4.11055 18.7035H8.59417C9.00517 18.7035 9.34144 18.371 9.34144 17.9563C9.34144 17.5415 9.00517 17.209 8.59417 17.209Z",
    fill: "#6FCAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6926 9.73624H18.6817C19.0927 9.73624 19.4289 9.39997 19.4289 8.98897C19.4289 8.57797 19.0927 8.2417 18.6817 8.2417H15.6926C15.2816 8.2417 14.9453 8.57797 14.9453 8.98897C14.9453 9.39997 15.2816 9.73624 15.6926 9.73624Z",
    fill: "#6FCAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3291 11.2307C12.3291 11.6417 12.6654 11.9779 13.0764 11.9779H20.9227C21.3337 11.9779 21.67 11.6417 21.67 11.2307C21.67 10.8197 21.3337 10.4834 20.9227 10.4834H13.0764C12.6654 10.4834 12.3291 10.8197 12.3291 11.2307Z",
    fill: "#6FCAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9243 17.209H10.8361C10.4251 17.209 10.0889 17.5453 10.0889 17.9563C10.0889 18.3673 10.4251 18.7035 10.8361 18.7035H20.9243C21.3353 18.7035 21.6715 18.3673 21.6715 17.9563C21.6715 17.5453 21.3353 17.209 20.9243 17.209Z",
    fill: "#6FCAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.f7242b8d581eb0ed2689b202c380dca9.svg";
export { ForwardRef as ReactComponent };